module.exports = __webpack_public_path__ + "static/media/QLIK_logo 800X533-01.ff734017.png";